import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME, brandLogoSrc } from '../config/branding';
import { AlertTriangleIcon } from './Icons';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">
              <span className="footer-brand-row">
                <img src={brandLogoSrc()} alt="" className="footer-brand-logo" width={24} height={24} />
                {APP_NAME}
              </span>
            </h3>
            <p className="footer-description">
              개인의 투자 기록을 체계적으로 관리하고<br />
              포트폴리오를 분석할 수 있는 서비스입니다.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">서비스</h4>
            <ul className="footer-links">
              <li><Link to="/">홈</Link></li>
              <li><Link to="/about">서비스 소개</Link></li>
              <li><Link to="/asset">자산관리</Link></li>
              <li><Link to="/notice">공지사항</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">정보</h4>
            <ul className="footer-links">
              <li><Link to="/terms">이용약관</Link></li>
              <li><Link to="/privacy">개인정보처리방침</Link></li>
              <li><Link to="/contact">문의하기</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">알림</h4>
            <p className="footer-disclaimer">
              <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '4px' }}><AlertTriangleIcon size={16} color="currentColor" /></span> 투자에 따른 손실은 본인에게 귀속됩니다.<br />
              투자는 신중하게 결정하시기 바랍니다.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} {APP_NAME}. All rights reserved.
          </p>
          <p className="footer-warning">
            개인의 판단에 따라 투자하세요
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


